import React, { useState } from 'react';

const AddCompanyForm = () => {
  const [formData, setFormData] = useState({
    sirenNumber: "",
    siretNumber: "",
    name: "",
    address: "",
    postcode: "",
    lat: "",
    lon: "",
    revenue: "",
    netProfit: ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const wsUrl = import.meta.env.VITE_REACT_APP_BACK_NODE_COMPANY_ENDPOINT;
    console.log(import.meta.env.VITE_REACT_APP_BACK_NODE_COMPANY_ENDPOINT)
    try {
      const response = await fetch(wsUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        const data = await response.json();
        console.log("response data: " + JSON.stringify(data));
        // Do something with the response data
      } else {
        const text = await response.text();
        console.log("error response text: " + text);
        // Handle error response
      }
    } catch (ex) {
      console.log("ex: " + ex);
      // Handle general error
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div>
        <label>SIREN Number:</label>
        <input
          type="text"
          name="sirenNumber"
          value={formData.sirenNumber}
          onChange={handleChange}
        />
      </div>
      <div>
        <label>SIRET Number:</label>
        <input
          type="text"
          name="siretNumber"
          value={formData.siretNumber}
          onChange={handleChange}
        />
      </div>
      <div>
        <label>Name:</label>
        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
        />
      </div>
      <div>
        <label>Address:</label>
        <input
          type="text"
          name="address"
          value={formData.address}
          onChange={handleChange}
        />
      </div>
      <div>
        <label>Postcode:</label>
        <input
          type="text"
          name="postcode"
          value={formData.postcode}
          onChange={handleChange}
        />
      </div>
      <div>
        <label>Latitude:</label>
        <input
          type="text"
          name="lat"
          value={formData.lat}
          onChange={handleChange}
        />
      </div>
      <div>
        <label>Longitude:</label>
        <input
          type="text"
          name="lon"
          value={formData.lon}
          onChange={handleChange}
        />
      </div>
      <div>
        <label>Revenue:</label>
        <input
          type="text"
          name="revenue"
          value={formData.revenue}
          onChange={handleChange}
        />
      </div>
      <div>
        <label>Net Profit:</label>
        <input
          type="text"
          name="netProfit"
          value={formData.netProfit}
          onChange={handleChange}
        />
      </div>
      <button type="submit">Add Company</button>
    </form>
  );
};

export default AddCompanyForm;
